import React, { useEffect } from "react";
import { useAuth } from "../config/AuthProvider.js"; // Importa el contexto
import { useNavigate, useLocation } from "react-router-dom"; // Usamos navigate y location

const AuthInterceptor = ({ children }) => {
  const { auth } = useAuth(); // Obtenemos el rol del contexto (ADMINS, USERS, GUEST)
  const navigate = useNavigate();
  const location = useLocation(); // Para obtener la ruta actual

  useEffect(() => {
    // Si el usuario es GUEST, redirigir a la página de inicio de sesión
    if (auth === "GUEST") {
      navigate("/IniciarSesion", { replace: true });
    }

    // Si el usuario es ADMIN pero intenta acceder a una ruta de usuario
    if (auth === "ADMINS" && location.pathname.startsWith("/user")) {
      navigate("/admin"); // Redirige a las rutas de administrador
    }

    // Si el usuario es USER pero intenta acceder a una ruta de administrador
    if (auth === "USERS" && location.pathname.startsWith("/admin")) {
      navigate("/user"); // Redirige a las rutas de usuario
    }
  }, [auth, location, navigate]); // Se actualiza cuando el rol o la ruta cambian

  return <>{children}</>; // Renderiza los hijos si todo es correcto
};

export default AuthInterceptor;
